import config from 'lib/config';
import { FavoriteDataItem } from 'types/Apis/Favorites';
import authorizedFetch from '../authorizedFetch';

async function addFavorite(vin: string): Promise<FavoriteDataItem> {
  return authorizedFetch(`${config.coreApiUrl}/favorites`, {
    method: 'POST',
    body: JSON.stringify({ vin }),
  });
}

export default addFavorite;
